import { SaleUser } from "../hooks/useSaleUserType";
import { SaleListUrlQueryParams, saleUrl, SaleUrlQueryParams } from "../urls";

export default function getSaleUpdateUrlByUserType(
  saleUser: SaleUser,
  saleId: string,
  params: SaleUrlQueryParams | SaleListUrlQueryParams
): string {
  if (saleUser.isKAMS) {
    return saleUrl(saleId) + `brand=${params.brand}`;
  }
  return saleUrl(saleId);
}
